/**
 * Sentry configuration. Everything Sentry needs is in this file — no .env entry
 * is required on any server, so deploying to a new region needs no extra setup.
 *
 * The DSN is a public, write-only key: it can only create events, never read or
 * delete them, and it is meant to ship inside the browser bundle.
 */

export default {
    dsn: 'https://a7aa2f50c9616e9ae57392a5b80fe31a@o4511902680416256.ingest.de.sentry.io/4511903915835472',
    enabledInDevelopment: false,
    tracesSampleRate: 0.1,
    debug: false,
    /**
     * Shown on every issue as "release", so you can see which deploy introduced a bug.
     * Bump it when you want a clean before/after line in Sentry.
     */
    release: 'dgstay-guest-web@0.1.0',
    sensitiveQueryKeys: [
        'send-email',
        'email',
        'phone',
        'token',
        'access_token',
        'api_key',
        'key',
        'password',
        'signature',
    ],

    /**
     * Scripts we do not own but that run inside our page (hotel.ext_data.scripts,
     * jivo, quicktext, GA, browser extensions). Their errors are not our bugs.
     */
    denyUrls: [
        /extensions\//i,
        /^chrome:\/\//i,
        /^chrome-extension:\/\//i,
        /^moz-extension:\/\//i,
        /^safari-(web-)?extension:\/\//i,
        /googletagmanager\.com/i,
        /google-analytics\.com/i,
        /gstatic\.com/i,
        /jivo(site)?\./i,
        /quicktext\.im/i,
        /mc\.yandex\.ru/i,
    ],

    /** Known noise that is not an application bug. */
    ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'ResizeObserver loop completed with undelivered notifications',
        'Non-Error promise rejection captured',
        'AbortError',
        // Guest lost connectivity (mobile / hotel wifi) — nothing we can fix
        'Network Error',
        // vue-router rejections when one navigation replaces another
        'Navigation cancelled',
        'Avoided redundant navigation',
        /^Redirected when going from/,
        // Autoplay policy on video_template / slider_template
        'The play() request was interrupted',
    ],
};
